export default {
    name: 'QPagination',
    props: {
        id: {
            type: String,
            default: 'q-pagination'
        },
        currentPage: {
            type: Number,
            default: 0
        },
        listLength: {
            type: Number,
            default: 0
        },
        defaultPageSize: {
            type: Number,
            default: 20
        },
        maxPageSize: {
            type: Number,
            default: 200
        },
        options: {
            type: Array,
            default: [
                {
                    label: '80',
                    value: '80'
                },
                {
                    label: '40',
                    value: '40'
                }
            ]
        }
    },
    created() {
        if (!this.maxPageSize) {
            this.maxPageSize = this.listLength;
        }
        this.selectOptions.push(...this.options);
    },
    data() {
        return {
            selectOptions: [
                {
                    label: this.$t('HC_ALL'),
                    value: this.listLength
                }
            ],
            pageSize: this.defaultPageSize
        };
    },
    methods: {
        prevPage() {
            this.currentPage === 0
                ? (this.currentPage = 0)
                : this.currentPage--;
            this.$parent.currentPage = this.currentPage;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        nextPage() {
            this.currentPage ===
            Math.floor((this.listLength - 1) / this.pageSize)
                ? (this.currentPage = this.currentPage)
                : this.currentPage++;
            this.$parent.currentPage = this.currentPage;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        updatePageSize(e) {
            this.$parent.currentPage = 0;
            this.currentPage = 0;
            this.pageSize = e;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    watch: {
        pageSize: function() {
            this.$parent.pageSize = this.pageSize;
        },
        listLength: function() {
            this.selectOptions[0].label =
                this.listLength > this.maxPageSize
                    ? this.maxPageSize.toString()
                    : this.$t('HC_ALL');
            this.selectOptions[0].value =
                this.listLength > this.maxPageSize
                    ? this.maxPageSize
                    : this.listLength;
        }
    },
    computed: {
        startItem() {
            return (this.currentPage + 1) * this.pageSize - this.pageSize + 1;
        },
        endItem() {
            const end = (this.currentPage + 1) * this.pageSize;
            return end > this.listLength ? this.listLength : end;
        },
        pages() {
            return Math.ceil(this.listLength / this.pageSize);
        }
    }
};
